/* eslint-disable no-undef,no-param-reassign,import/named,consistent-return */
/**
 * Created by chengzhenfu on 2019/5/5.
 * Modified by  on .
 *请求方法模块
 */

import Vue from "vue";
import fetch from "./fetch.js";
import Qs from "qs";
// import axios from 'axios'
// // Promise的finally回调 不论成功与否都会调用
// Promise.prototype.finally = function (callback) {
//   let P = this.constructor;
//   return this.then(
//   value  => P.resolve(callback()).then(() => value),
//   reason => P.resolve(callback()).then(() => { throw reason })
//   );
// };

const http = {
  get(url, base, config) {
    const data = {
      params: base,
    };
    return fetch(url, data, config);
  },
  down(url, base, config) {
    const data = {
      params: base,
    };
    return fetch(url, data, config).then((res) => {
      // console.log(res)
      if (typeof res === "string") {
        const elink = document.createElement("a");

        elink.style.display = "none";
        elink.href = res;
        document.body.appendChild(elink);
        elink.click();

        document.body.removeChild(elink);
      }
    });
  },
  // post(...arr) {
  //     return fetch.post(...arr)
  // },
  post(url, data) {
    return fetch.post(url, data, {
      transformRequest: [
        (data) => {
          return Qs.stringify(data);
        },
      ],

      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  },
  fileUp(url, data) {
    return fetch({
      method: "post",
      url,
      data,

      headers: {
        "Content-Type": "multipart/form-data",
      },
      // headers: {
      //   'Content-Type': 'application/json',
      // }
    });
  },
  put(url, base, config) {
    // let data={data:base};

    const data = base;

    return fetch.put(url, data, config);
  },
  delete(url, base, config) {
    const data = {
      data: base,
    };
    return fetch.delete(url, data, config);
  },
};
Vue.prototype.$http = http;
export default http;
